import React from 'react'

const TPORequestsIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3831 9.125H15.2839C15.0448 9.125 14.8175 9.23984 14.6769 9.43672L10.9925 14.5461L9.32373 12.2305C9.18311 12.0359 8.95811 11.9188 8.7167 11.9188H7.61748C7.46514 11.9188 7.37608 12.0922 7.46514 12.2164L10.3855 16.2664C10.4544 16.3627 10.5454 16.4412 10.6508 16.4953C10.7561 16.5494 10.8729 16.5776 10.9913 16.5776C11.1098 16.5776 11.2265 16.5494 11.3319 16.4953C11.4372 16.4412 11.5282 16.3627 11.5972 16.2664L16.5331 9.42266C16.6245 9.29844 16.5355 9.125 16.3831 9.125Z"
        fill="white"
      />
      <path
        d="M12 2.35156C6.20156 2.35156 1.5 7.05313 1.5 12.8516C1.5 18.65 6.20156 23.3516 12 23.3516C17.7984 23.3516 22.5 18.65 22.5 12.8516C22.5 7.05313 17.7984 2.35156 12 2.35156ZM12 21.5703C7.18594 21.5703 3.28125 17.6656 3.28125 12.8516C3.28125 8.0375 7.18594 4.13281 12 4.13281C16.8141 4.13281 20.7188 8.0375 20.7188 12.8516C20.7188 17.6656 16.8141 21.5703 12 21.5703Z"
        fill="white"
      />
    </svg>
  )
}

export default TPORequestsIcon
